import script from "./BroadcastComposeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BroadcastComposeModal.vue?vue&type=script&setup=true&lang=ts"

import "./BroadcastComposeModal.vue?vue&type=style&index=0&id=10d4d27c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10d4d27c"]])

export default __exports__